import { transparentize } from "polished";
import { Colors } from "./colors";

export const BoxShadow = {
  Default: `0px 5px 20px ${transparentize(0.9, Colors.ShadowBlue)}`,
  Hover: `0px 8px 20px ${transparentize(0.85, Colors.ShadowBlue)}`,
  Pop: `0px 15px 20px ${transparentize(0.85, Colors.ShadowBlue)}`,
};
